import React from 'react';
import general from "../../../utils/general";

const CpfRender = ({value}) => {

    return (
        <div>
            <span >{general.formatCpf(value)}</span>
        </div>
    );
};

export default CpfRender;